import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { CustomCellRendererProps } from 'ag-grid-react';
import { Icon, Tooltip } from '@wk/components-v3-react16';
import { ServerDashboardJob } from '../../dashboardType';
import { MAP_STATUS_ICON } from '../../StatusButtons/iconsConstants';
import styles from './StatusCell.module.scss';

const StatusCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const status = properties.data?.status;

  if (!status) {
    return null;
  }

  const statusConfig = MAP_STATUS_ICON[status as keyof typeof MAP_STATUS_ICON];

  if (!statusConfig) {
    return <span>{status}</span>;
  }

  const cellId = `status-${properties.data?.jobId}`;

  return (
    <>
      <div className={styles.container}>
        <div
          id={cellId}
          className={styles.iconWrapper}
          onMouseEnter={() => setIsTooltipOpen(true)}
          onMouseLeave={() => setIsTooltipOpen(false)}
          style={{ color: statusConfig.color, fontSize: statusConfig.size }}
        >
          <Icon
            name={statusConfig.name}
            aria-label={statusConfig.description}
          />
        </div>
      </div>
      {createPortal(
        <Tooltip
          targetSelector={`#${cellId}`}
          isOpen={isTooltipOpen}
          position="top"
        >
          {statusConfig.description}
        </Tooltip>,
        document.querySelector('#root') as HTMLElement
      )}
    </>
  );
};

export default StatusCell;
